/**
 * AssessConversation — /assess/conversation (Phase 3, mock).
 *
 * Conversation step of the 1-2-1 take flow. Reuses the existing
 * AssessmentAiPanel (a mock, 5-prompt-capped conversation surface) inside the
 * 4-step flow stepper, and provides a "Continue to baseline report" action.
 *
 * NOTE — divergence from verbal-preview: the prototype used a fixed 4-turn
 * scripted exchange (AIConversationPage). We instead reuse the repo's own
 * AssessmentAiPanel (VER-58) so the conversation surface, prompt counter and
 * safety framing stay consistent with the rest of the assess area. The cap is
 * UX-only; the real server enforces it (see AssessmentAiPanel header).
 *
 * FRONTEND-ONLY.
 * TODO[RBAC]: gate at the route level with the AssessView permit once defined.
 * TODO[CONSENT]: this surface shows AI analysis over assessment data — run
 *   verbal-consent-audit before release.
 */
import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { ArrowForwardOutlined } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useMobile } from "../../../hooks/useMobile";
import { AssessmentAiPanel } from "../assessmentAi/AssessmentAiPanel";
import { AssessFlowStepper } from "./AssessFlowStepper";
import { useAssessFlow } from "./AssessFlowContext";

export const AssessConversation = (): JSX.Element => {
    const { isMobile, isTablet } = useMobile();
    const padding = !isTablet && isMobile ? 2 : 4;
    const navigate = useNavigate();
    const { state } = useAssessFlow();

    const title = state.score?.scaleName ?? "Assessment (preview)";

    return (
        <Box p={padding} width={1}>
            {!isTablet && isMobile && <Box pt={8} />}

            <Typography variant="h2" color="textPrimary" mb={3}>
                Conversation
            </Typography>

            <AssessFlowStepper activeStep={2} />

            <Box sx={{ height: { xs: 480, md: 560 }, mb: 3 }}>
                <AssessmentAiPanel assessmentTitle={title} />
            </Box>

            <Box display="flex" justifyContent="space-between" gap={2} flexWrap="wrap">
                <Button variant="outlined" color="primary" onClick={() => navigate(-1)}>
                    Back
                </Button>
                <Button
                    variant="contained"
                    color="primary"
                    endIcon={<ArrowForwardOutlined />}
                    onClick={() => navigate("/assess/report")}
                >
                    Continue to baseline report
                </Button>
            </Box>
        </Box>
    );
};

export default AssessConversation;
